export const datosCalculadora = {
    ARGENTINA: {
        DE16A20: {
            valor: 2.5,
            casos: {
                100: 5,
                150: 7,
                200: 9,
                250: 11,
                300: 15
            }
        },
        DE20A30: {
            valor: 2,
            casos: {
                100: 1,
                150: 2,
                200: 2,
                250: 3,
                300: 4
            }
        },
        MAS30: {
            valor: 3,
            casos: {
                100: 2,
                150: 2,
                200: 3,
                250: 4,
                300: 5
            }
        }
    },
    BOLIVIA: {
        DE16A20: {
            valor: 2.75,
            casos: {
                100: 5,
                150: 7,
                200: 9,
                250: 11,
                300: 15
            }
        },
        DE20A30: {
            valor: 2.15,
            casos: {
                100: 3,
                150: 4,
                200: 6,
                250: 7,
                300: 9
            }
        },
        MAS30: {
            valor: 3.25,
            casos: {
                100: 3,
                150: 4,
                200: 6,
                250: 7,
                300: 9
            }
        }
    },
    BRASIL: {
        DE16A20: {
            valor: 3.25,
            casos: {
                100: 6,
                150: 8,
                200: 11,
                250: 14,
                300: 18
            }
        },
        DE20A30: {
            valor: 2.75,
            casos: {
                100: 4,
                150: 6,
                200: 7,
                250: 9,
                300: 12
            }
        },
        MAS30: {
            valor: 4.25,
            casos: {
                100: 4,
                150: 6,
                200: 7,
                250: 9,
                300: 12
            }
        }
    },
    CHILE: {
        DE16A20: {
            valor: 2.75,
            casos: {
                100: 5,
                150: 7,
                200: 9,
                250: 11,
                300: 15
            }
        },
        DE20A30: {
            valor: 2.15,
            casos: {
                100: 1,
                150: 2,
                200: 2,
                250: 3,
                300: 3
            }
        },
        MAS30: {
            valor: 3.25,
            casos: {
                100: 2,
                150: 3,
                200: 4,
                250: 5,
                300: 6
            }
        }
    },
    COLOMBIA: {
        DE16A20: {
            valor: 2.5,
            casos: {
                100: 5,
                150: 7,
                200: 9,
                250: 11,
                300: 15
            }
        },
        DE20A30: {
            valor: 2,
            casos: {
                100: 1,
                150: 2,
                200: 2,
                250: 3,
                300: 3
            }
        },
        MAS30: {
            valor: 3,
            casos: {
                100: 2,
                150: 3,
                200: 4,
                250: 5,
                300: 6
            }
        }
    },
    COSTARICA: {
        DE16A20: {
            valor: 3.25,
            casos: {
                100: 5,
                150: 7,
                200: 9,
                250: 11,
                300: 15
            }
        },
        DE20A30: {
            valor: 2.75,
            casos: {
                100: 3,
                150: 4,
                200: 6,
                250: 7,
                300: 9
            }
        },
        MAS30: {
            valor: 4.25,
            casos: {
                100: 3,
                150: 4,
                200: 6,
                250: 7,
                300: 9
            }
        }
    },
    DOMINICANA: {
        DE16A20: {
            valor: 3.25,
            casos: {
                100: 5,
                150: 7,
                200: 9,
                250: 11,
                300: 15
            }
        },
        DE20A30: {
            valor: 2.75,
            casos: {
                100: 1,
                150: 2,
                200: 2,
                250: 3,
                300: 3
            }
        },
        MAS30: {
            valor: 4.25,
            casos: {
                100: 2,
                150: 2,
                200: 3,
                250: 4,
                300: 5
            }
        }
    },
    ECUADOR: {
        DE16A20: {
            valor: 2.5,
            casos: {
                100: 4,
                150: 6,
                200: 7,
                250: 9,
                300: 12
            }
        },
        DE20A30: {
            valor: 2,
            casos: {
                100: 1,
                150: 2,
                200: 2,
                250: 3,
                300: 3
            }
        },
        MAS30: {
            valor: 3,
            casos: {
                100: 2,
                150: 3,
                200: 4,
                250: 5,
                300: 6
            }
        }
    },
    GUATEMALA: {
        DE16A20: {
            valor: 3.25,
            casos: {
                100: 5,
                150: 7,
                200: 9,
                250: 11,
                300: 15
            }
        },
        DE20A30: {
            valor: 2.75,
            casos: {
                100: 3,
                150: 4,
                200: 6,
                250: 7,
                300: 9
            }
        },
        MAS30: {
            valor: 4.25,
            casos: {
                100: 3,
                150: 4,
                200: 6,
                250: 7,
                300: 9
            }
        }
    },
    HONDURAS: {
        DE16A20: {
            valor: 3.25,
            casos: {
                100: 5,
                150: 7,
                200: 9,
                250: 11,
                300: 15
            }
        },
        DE20A30: {
            valor: 2.75,
            casos: {
                100: 4,
                150: 6,
                200: 7,
                250: 9,
                300: 12
            }
        },
        MAS30: {
            valor: 4.25,
            casos: {
                100: 4,
                150: 6,
                200: 7,
                250: 9,
                300: 12
            }
        }
    },
    MEXICO: {
        DE16A20: {
            valor: 2.5,
            casos: {
                100: 6,
                150: 8,
                200: 11,
                250: 14,
                300: 18
            }
        },
        DE20A30: {
            valor: 2,
            casos: {
                100: 4,
                150: 6,
                200: 7,
                250: 9,
                300: 12
            }
        },
        MAS30: {
            valor: 3,
            casos: {
                100: 4,
                150: 6,
                200: 7,
                250: 9,
                300: 12
            }
        }
    },
    PANAMA: {
        DE16A20: {
            valor: 3.25,
            casos: {
                100: 6,
                150: 8,
                200: 11,
                250: 14,
                300: 18
            }
        },
        DE20A30: {
            valor: 2.75,
            casos: {
                100: 4,
                150: 6,
                200: 7,
                250: 9,
                300: 12
            }
        },
        MAS30: {
            valor: 4.25,
            casos: {
                100: 4,
                150: 6,
                200: 7,
                250: 9,
                300: 12
            }
        }
    },
    PERU: {
        DE16A20: {
            valor: 2.5,
            casos: {
                100: 6,
                150: 8,
                200: 11,
                250: 14,
                300: 18
            }
        },
        DE20A30: {
            valor: 2,
            casos: {
                100: 4,
                150: 5,
                200: 7,
                250: 9,
                300: 12
            }
        },
        MAS30: {
            valor: 3,
            casos: {
                100: 4,
                150: 5,
                200: 7,
                250: 9,
                300: 12
            }
        }
    },
    URUGUAY: {
        DE16A20: {
            valor: 2.75,
            casos: {
                100: 6,
                150: 8,
                200: 11,
                250: 14,
                300: 18
            }
        },
        DE20A30: {
            valor: 2.15,
            casos: {
                100: 4,
                150: 6,
                200: 7,
                250: 9,
                300: 12
            }
        },
        MAS30: {
            valor: 3.25,
            casos: {
                100: 4,
                150: 6,
                200: 7,
                250: 9,
                300: 12
            }
        }
    }
};
